import React from 'react';
import { Tooltip as UIBricksTooltip } from '@makemydeal/ui-bricks/dist/cox';

export type TooltipProps = {
    /** The tooltip message. The ui-bricks Tooltip renders this on hover. */
    children: string;
    placement?: 'top' | 'right' | 'bottom';
    /** Optional custom trigger icon; falls back to the ui-bricks info icon. */
    icon?: React.ReactNode;
};

/**
 * Thin wrapper around the ui-bricks Tooltip so the rest of the app has a single,
 * typed entry point (matching the other ui-bricks wrappers in this lib). The
 * ui-bricks Tooltip renders its own trigger icon and reveals `children` (the
 * message) on hover — it is not a wrapper around a target element.
 */
const Tooltip: React.FC<TooltipProps> = (props) => {
    return <UIBricksTooltip {...props} />;
};

export default Tooltip;
